module.exports = __webpack_public_path__ + "static/593309604.360f5bee.jpg";